import React from 'react'

export default function PricingPage() {
  return (
    <div>
      
    </div>
  )
}
